import type { FC } from 'react'

import { useApiKey } from 'core/auth/authStore'
import Auth from 'pages/auth/Auth'
import Companies from 'pages/companies/Companies'
import CreateCompany from 'pages/companies/CreateCompany'
import Env from 'pages/env/Env'
import { Markdown, ListNav2, Panels } from 'peach/components'
import { Switch, Route, Redirect } from 'peach/router'

import development from './development.md'
import localData from './local-data.md'
import notes from './notes.md'
import Status from './Status'
import Admin from 'pages/admin'

const markdown = `
  # Welcome to 🍑 Dev Tools\n
  Read the [readme.md](https://github.com/peachfinance/dev-tools/blob/master/README.md) for more.
`

// but in this particular case though, we are importing from outside of the /src folder and that doesn't work, BUT the macro plugin does, so we improt the readme this way.
const sectionNavItems = [
  '/companies',
  '/create-company',
  // '/all-roles',
  '/auth',
  '/env',
] as const

const Home: FC = () => {
  const apiKey = useApiKey()
  const items = [
    ['Home', '', true],
    '/status',
    '/local-data',
    '/notes',
    '/development',
    {
      label: 'Sections',
      items: [...sectionNavItems, ...(apiKey ? (['/admin'] as const) : [])],
    },
  ]

  return (
    <Panels left={<ListNav2 items={items} searchable={false} />}>
      <Switch>
        <Route crumb exact path='/home'>
          <Markdown markdown={markdown} withCenteredPage />
        </Route>

        <Route crumb path='/status'>
          <Status />
        </Route>

        <Route crumb path='/local-data'>
          <Markdown markdown={localData} withCenteredPage />
        </Route>

        <Route crumb path='/development'>
          <Markdown markdown={development} withCenteredPage />
        </Route>

        <Route crumb path='/notes'>
          <Markdown markdown={notes} withCenteredPage />
        </Route>

        <Route crumb exact path='/companies'>
          <Companies />
        </Route>

        <Route crumb exact path='/create-company'>
          <CreateCompany />
        </Route>

        {/* <Route crumb path='/all-roles' title='All Roles'>
        <AllRoles />
      </Route> */}

        <Route crumb path='/auth'>
          <Auth />
        </Route>

        <Route crumb path='/env'>
          <Env />
        </Route>

        {apiKey && (
          <Route crumb path='/admin'>
            <Admin />
          </Route>
        )}

        <Redirect to='/home' />
      </Switch>
    </Panels>
  )
}

export default Home
